<script setup>
import { watch, computed } from 'vue';
import { useApiSlugs } from '@/composables/useApiSlugs';
import { useCmsPage } from '@/composables/useCmsPage';

import CarPage from '@/components/layout/CarPage.vue';
import Page from '@/components/layout/Page.vue';
import AosContainer from '@/components/AosContainer.vue';

const { getPageSlug } = useApiSlugs();
const apiSlug = computed(() => getPageSlug());

const { data } = await useCmsPage(apiSlug);

const isRedirect = computed(() => !!data.value?.redirect?.redirect_url);
const isCarPage = computed(() =>
  !isRedirect.value ? !!data.value?.data?.['type_of_transport'] : null,
);
</script>

<template>
  <AosContainer
    v-if="data?.success && !isRedirect"
    :options="{ once: true, duration: 600, easing: 'ease-out' }"
  >
    <div v-if="data?.success">
      <CarPage v-if="isCarPage" :data="data?.data" />
      <Page v-else :data="data?.data" :is-catalog="true" />
    </div>
  </AosContainer>
</template>
